module.exports = __webpack_public_path__ + "img/CASUTA_INFO.87161acb.png";